import React, { useState, useEffect, useCallback, useRef } from "react";
import { INDEX_URL, CUST, icons, FLAVOR, logos, markers, images } from "../../helpers/constants";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, { marker } from 'leaflet';
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import * as request from "../../services/FetchService";
import { useParams } from "react-router";

const StolenModeMap = (props) => {
    const { t } = useTranslation();
    let params = useParams();
    const intervalId = useRef(null);
    const token = params.token
    const [mapType, setMapType] = useState(0)
    const [data, setData] = useState()
    const [lastPosition, setLastPosition] = useState([0, 0])
    const lightTiles = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    const darkTiles = 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png'; // Example of dark mode
    const satelliteTiles = 'https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.png';
    const [looping, setLooping] = useState(false)
    const [initialMove, setInitialMove] = useState(false)
    const customDeviceIcon = L.icon({
        iconUrl: markers.blue.default,
        iconSize: [45, 45], // Width and height in pixels
        iconAnchor: [22.5, 45], // Point of the icon which corresponds to the marker's location
        popupAnchor: [0, -45], // Point from which the popup should open relative to the iconAnchor
    });

    console.log("ZUP?: ", token)
    useEffect(() => {
        getInitialInfo()
    }, [])

    const getInitialInfo = () => {
        request.postUnique("", "other/v1/devices/stolen/positions", { token: token }).then((response) => {
            console.log("RESPONSEY?: ", response)
            if (response.data) {
                setData(response?.data?.response)
                const lat = response?.data?.response?.latitude
                const lng = response?.data?.response?.longitude
                setLastPosition([lat, lng])
                setLooping(true)
                toast.success(t("toast.saved"));
            }else{
                toast.error(t("toast.error"))
            }
        })
    }

    const updateData = useCallback(() => {
        if(token)

            request.postUnique("", "other/v1/devices/stolen/positions", { token: token }).then((response) => {
                console.log("RESPONSEY?: ", response)
                if (response.data) {
                    setData(response?.data?.response)
                    const lat = response?.data?.response?.latitude
                    const lng = response?.data?.response?.longitude
                    setLastPosition([lat, lng])
                    toast.success(t("toast.data_updated"));
                }else{
                    toast.error(t("toast.error"))
                }
            })

    }, [data]);

    const startInterval = useCallback(() => {
        setLooping(true);
        intervalId.current = setInterval(updateData, 10000);
    }, [updateData]);

    const stopInterval = useCallback(() => {
        setLooping(false);
        if(intervalId.current){
            clearInterval(intervalId.current)
        }
    }, []);


    useEffect(() => {
        if (looping) {
            startInterval();
        } else {
            stopInterval();
        }
        return () => {
            stopInterval(); // Cleanup function to stop interval when unmounting
        };
    }, [looping, startInterval, stopInterval]);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                stopInterval(); // Pause interval when window is in background
            } else {
                startInterval(); // Resume interval when window is in foreground
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            stopInterval(); // Cleanup function to stop interval when unmounting
        };
    }, [startInterval, stopInterval]);    



    const calculateAge = (fixtime) => {
        if (!fixtime) return "";

        const timestamp = new Date(fixtime);
        const currentTime = new Date();
        const diffMs = currentTime - timestamp; // milliseconds

        const diffSec = Math.floor(diffMs / 1000);
        const diffMin = Math.floor(diffSec / 60);
        const diffHr = Math.floor(diffMin / 60);

        if (diffHr > 0) {
            return (<p>{t("stolenmode.position_age_1")} <span className="bold">{diffHr} {t("stolenmode.hour", {count : diffHr})}</span> {t("stolenmode.position_age_3")}</p>)
        } else if (diffMin > 0) {
            return (<p>{t("stolenmode.position_age_1")} <span className="bold">{diffMin} {t("stolenmode.minute", {count : diffMin})}</span> {t("stolenmode.position_age_3")}</p>)
        } else {
            return (<p>{t("stolenmode.position_age_1")} <span className="bold">{diffSec} {t("stolenmode.second", {count : diffSec})}</span> {t("stolenmode.position_age_3")}</p>)
        }
    };

    const toggleMapMode = () => {
        const value = mapType > 2 ? 1 : mapType + 1
        setMapType(value)
    }

    const StolenMappy = ({ position }) => {
          const map = useMap();

            useEffect(() => {
                if (position[0] !== 0 && position[1] !== 0 && !initialMove) {
                setInitialMove(true)
                map.setView(position);
                }
            }, [position]);
        return null
    }

    return(
        <>
        <MapContainer center={lastPosition} zoom={13} style={{ position: 'relative', height: '100vh', width: '100%' }} zoomControl={false}>
            <StolenMappy position={lastPosition} />
            <TileLayer
                url={
                    mapType === 1 
                    ? lightTiles 
                    : mapType === 2
                    ? darkTiles
                    : satelliteTiles
                }
            />
            <div className="stolenmode-map top-left logo px-4 py-3">
                <img src={logos.big} alt="" className="w-100"/>
            </div>

            <div className="stolenmode-map bottom-left px-2 py-2 data bg-white">
                <div className="d-flex w-100">
                    <div className="d-flex flex-column align-self-center">
                        <p>{t("stolenmode.fetching_data")} <span className="me-2 size_15 spinner-grow"/></p>
                        {calculateAge(data?.fixtime)}
                        <p>{t("stolenmode.speed")}: <span className="bold">{data?.speed ?? 0} km/h</span></p>
                    </div>
                    <img src={
                    mapType === 1 
                        ? icons.dark_map 
                        : mapType === 2
                        ? icons.satellite_map
                        : icons.light_map
                        } alt="" className="ms-5 map-type-img align-self-center cursor-pointer" onDoubleClick={(e) => e.stopPropagation()} onClick={() => toggleMapMode()}/>
                </div>
            </div>

            <div className="stolenmode-map bottom-right data bg-white">
                <div className="d-flex w-100">
                    <img src={data?.url ?? images.placeholder_img} alt="" className="h-100 user-info"/>
                    <div className="d-flex flex-column align-self-center py-3 mx-3">
                        <h4>{t("stolenmode.info_user")}</h4>
                        <p>{data?.description ?? t("stolenmode.no_info")}</p>
                        <img src={icons.info_icon} alt="" className="position-absolute top-0 end-0 me-2 mt-2" />
                    </div>
                </div>   
            </div>
            <Marker position={lastPosition} icon={customDeviceIcon} />

            {/* <Marker position={position}>
                <Popup>
                    This is Stockholm!
                </Popup>
            </Marker> */}
        </MapContainer>
        </>
    )
}
export default StolenModeMap;
